<script>
import { authComputed } from "@/state/helpers";
export default {
  name: "syncData",
  data() {
    return {
      syncDataUrl: ``
    };
  },
  computed: {
    ...authComputed,
  },
  created(){
    this.syncDataUrl = `${process.env.VUE_APP_NEXT360_URL}/login_app?np_merchant_id=${this.currentUser.merchantId}&np_user_id=${this.currentUser.userId}&np_location_id=${this.currentLocation}&np_app_id=${process.env.VUE_APP_ID}&token=${this.currentToken}`
  },
  components: {
  }
};
</script>

<style scoped>
.frame-sync {
  background: #c4c4c4;
}
</style>
<template>
  <TheLayout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">
            Thiết lập đồng bộ thông tin
          </h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-embed
              class="frame-sync"
              allowfullscreen
              aspect="21by9"
              :src="syncDataUrl"
            ></b-embed>
          </div>
        </div>
      </div>
    </div>
  </TheLayout>
</template>
